import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  imports: [RouterModule],
  selector: 'app-header-signin',
  styleUrl: './header-signin.component.scss',
  templateUrl: './header-signin.component.html'
})
export class HeaderSigninComponent {}
